import React, { createContext, useContext, useEffect, useState } from "react";
import { api, CUSTOMER_TOKEN_KEY, isTokenExpired } from "../lib/api";

const AuthContext = createContext(null);
const USER_KEY = "ayome_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    const saved = localStorage.getItem(USER_KEY);
    if (token && isTokenExpired(token)) {
      localStorage.removeItem(CUSTOMER_TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      setSessionExpired(true);
    } else if (token && saved) {
      try {
        setUser(JSON.parse(saved));
      } catch (e) {
        localStorage.removeItem(USER_KEY);
      }
    }
    setLoading(false);
  }, []);

  const persist = (token, u) => {
    localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(u));
    setUser(u);
  };

  const login = async (emailOrPhone, password) => {
    const { data } = await api.post("/customer/login", {
      email_or_phone: emailOrPhone,
      password,
    });
    persist(data.access_token, data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/customer/register", payload);
    persist(data.access_token, data.user);
    return data.user;
  };

  const googleSession = async (session_id) => {
    const { data } = await api.post("/customer/google-session", { session_id });
    persist(data.access_token, data.user);
    return { needs_profile: data.needs_profile, user: data.user };
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/customer/profile", payload);
    localStorage.setItem(USER_KEY, JSON.stringify(data));
    setUser(data);
    return data;
  };

  const setAvatar = (data) => {
    localStorage.setItem(USER_KEY, JSON.stringify(data));
    setUser(data);
  };

  const logout = () => {
    localStorage.removeItem(CUSTOMER_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, sessionExpired, isAuthenticated: !!user, login, register, googleSession, updateProfile, setAvatar, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
